// extracted by mini-css-extract-plugin
export var cardHeader = "_gq-1";
export var contentCard = "_gq-0";
export var headerActions = "_gq-3";
export var reorderHandle = "_gq-5";
export var titleArea = "_gq-2";
export var titleAreaWithHandle = "_gq-4";